import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Quick Button
 */
const ListButton = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, id, type } = item;
  return (
    <>
      <div className="_list_button_div" >
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
            <div className="_list_button_area" key={`${id}_${idx}_area`}>
              <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value, tempItem.button.action)}>
                {ReactHtmlParser(tempItem?.button?.label || '')}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
ListButton.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ListButton.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

export default ListButton;
